import {
  APPLICATION_DATA_REQUESTING,
  APPLICATION_DATA_ERROR,
  APPLICATION_DATA_SUCCESS,
} from "./constants";

const initialState: ApplicationState = {
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  festivalDates: ["2022-08-12", "2022-08-13", "2022-08-14"],
  initialApplicationDataLoadCompleted: false,
  applicationData: {
    artists: [],
    arts: [],
    families: [],
    foods: [],
    venues: [],
  },
};

export default (
  state: ApplicationState = initialState,
  action: any
): ApplicationState => {
  const { type } = action;

  switch (type) {
    case APPLICATION_DATA_REQUESTING: {
      return {
        ...state,
        requesting: false,
        successful: false,
        messages: [],
        errors: [],
      };
    }

    case APPLICATION_DATA_SUCCESS: {
      return {
        ...state,
        initialApplicationDataLoadCompleted: true,
        applicationData: action.data.getAppData,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      };
    }

    case APPLICATION_DATA_ERROR: {
      return {
        ...state,
        requesting: false,
        successful: false,
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/application/reducer.ts